import { render, staticRenderFns } from "./BookingFlights.vue?vue&type=template&id=bbe38168&"
import script from "./BookingFlights.vue?vue&type=script&lang=js&"
export * from "./BookingFlights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports